
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Auth from './pages/Auth';
import AuthCallback from './pages/AuthCallback';
import Games from './pages/Games';
import Friends from './pages/Friends';
import GameDetail from './pages/GameDetail';
import GameEdit from './pages/GameEdit';
import Scoring from './pages/Scoring';
import Onboarding from './pages/Onboarding';
import Courses from './pages/Courses';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import HowToPlay from './pages/HowToPlay';
import { Toaster } from "@/components/ui/toaster";
import AuthGuard from './components/AuthGuard';
import ErrorBoundary from './components/ErrorBoundary';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

function App() {
  return (
    <Router>
      <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/how-to-play" element={<HowToPlay />} />
            
            {/* Onboarding (auth required, but skip onboarding check) */}
            <Route path="/onboarding" element={<AuthGuard skipOnboardingCheck><Onboarding /></AuthGuard>} />

            {/* Protected routes */}
            <Route path="/profile" element={<AuthGuard><Profile /></AuthGuard>} />
            <Route path="/" element={<AuthGuard><Home /></AuthGuard>} />
            <Route path="/games" element={<AuthGuard><Games /></AuthGuard>} />
            <Route path="/games/:gameId" element={<AuthGuard><GameDetail /></AuthGuard>} />
            <Route path="/games/:gameId/edit" element={<AuthGuard><GameEdit /></AuthGuard>} />
            <Route path="/courses" element={<AuthGuard><Courses /></AuthGuard>} />
            <Route path="/friends" element={<AuthGuard><Friends /></AuthGuard>} />
            <Route path="/scoring" element={<AuthGuard><Scoring /></AuthGuard>} />
            <Route path="/scoring/:gameId" element={<AuthGuard><Scoring /></AuthGuard>} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </QueryClientProvider>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
